// Feriados irrenunciables de Chile 2026-2027.
// Fuente: Ley 2.977 y modificaciones vigentes.

export const FERIADOS_CL = {
  '2026': [
    { fecha: '2026-01-01', nombre: 'Año Nuevo' },
    { fecha: '2026-04-03', nombre: 'Viernes Santo' },
    { fecha: '2026-04-04', nombre: 'Sábado Santo' },
    { fecha: '2026-05-01', nombre: 'Día del Trabajador' },
    { fecha: '2026-05-21', nombre: 'Día de las Glorias Navales' },
    { fecha: '2026-06-29', nombre: 'San Pedro y San Pablo' },
    { fecha: '2026-07-16', nombre: 'Virgen del Carmen' },
    { fecha: '2026-08-15', nombre: 'Asunción de la Virgen' },
    { fecha: '2026-09-18', nombre: 'Independencia Nacional' },
    { fecha: '2026-09-19', nombre: 'Glorias del Ejército' },
    { fecha: '2026-10-12', nombre: 'Encuentro de Dos Mundos' },
    { fecha: '2026-10-31', nombre: 'Día de las Iglesias Evangélicas' },
    { fecha: '2026-11-01', nombre: 'Día de Todos los Santos' },
    { fecha: '2026-12-08', nombre: 'Inmaculada Concepción' },
    { fecha: '2026-12-25', nombre: 'Navidad' },
  ],
  '2027': [
    { fecha: '2027-01-01', nombre: 'Año Nuevo' },
    { fecha: '2027-03-26', nombre: 'Viernes Santo' },
    { fecha: '2027-03-27', nombre: 'Sábado Santo' },
    { fecha: '2027-05-01', nombre: 'Día del Trabajador' },
    { fecha: '2027-05-21', nombre: 'Día de las Glorias Navales' },
    { fecha: '2027-06-29', nombre: 'San Pedro y San Pablo' },
    { fecha: '2027-07-16', nombre: 'Virgen del Carmen' },
    { fecha: '2027-08-15', nombre: 'Asunción de la Virgen' },
    { fecha: '2027-09-18', nombre: 'Independencia Nacional' },
    { fecha: '2027-09-19', nombre: 'Glorias del Ejército' },
    { fecha: '2027-10-12', nombre: 'Encuentro de Dos Mundos' },
    { fecha: '2027-10-31', nombre: 'Día de las Iglesias Evangélicas' },
    { fecha: '2027-11-01', nombre: 'Día de Todos los Santos' },
    { fecha: '2027-12-08', nombre: 'Inmaculada Concepción' },
    { fecha: '2027-12-25', nombre: 'Navidad' },
  ],
};

// Set interno para búsqueda O(1)
const FECHAS_SET = new Set(
  Object.values(FERIADOS_CL).flat().map(f => f.fecha)
);

// Map para nombres de feriados
const NOMBRES_MAP = new Map(
  Object.values(FERIADOS_CL).flat().map(f => [f.fecha, f.nombre])
);

// Recibe un Date o string ISO (YYYY-MM-DD). Ignora hora.
export function esFeriado(date) {
  const d = date instanceof Date ? date : new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return FECHAS_SET.has(`${y}-${m}-${day}`);
}

export function getNombreFeriado(date) {
  const d = date instanceof Date ? date : new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return NOMBRES_MAP.get(`${y}-${m}-${day}`) || null;
}
